module.exports = __webpack_public_path__ + "img/hand.d4d42dae.png";